/* eslint-disable max-len */
/**
 * Games only available in the zh-TW (Traditional Chinese) market preview.
 * Not yet live in other markets — injected at display time only, never cached.
 */
const ZH_TW_ONLY_GAMES = [
  {
    code: 'pirates-treasure-reel-2',
    name: 'Pirates Treasure Reel 2',
    type: 'SLOT',
    rtp: 97,
    maxWin: 50000,
    volatility: 'high',
    status: 'ACTIVE',
    isNew: true,
    created: new Date('2026-05-09'),
    popularIndex: 0,
    isPopular: false,
    preview: 'https://cdn.rg-lgna.com/cdn-cgi/image/height=1024,fit=scale-down,format=auto/games/1775817897957-2KgacUMHuI.png',
    provider: { id: 'rc', code: 'rc', name: 'Rectangle Games' },
    providerId: 'rc',
    family: 'pirates treasure',
  },
  {
    code: 'realm-of-thunder-2',
    name: 'Realm of Thunder 2',
    type: 'SLOT',
    rtp: 97,
    maxWin: 50000,
    volatility: 'high',
    status: 'ACTIVE',
    isNew: true,
    created: new Date('2026-05-09'),
    popularIndex: 0,
    isPopular: false,
    preview: 'https://cdn.rg-lgna.com/cdn-cgi/image/height=1024,fit=scale-down,format=auto/games/1775817959950-iFiAE1ui7P.jpg',
    provider: { id: 'rc', code: 'rc', name: 'Rectangle Games' },
    providerId: 'rc',
    family: 'thunder',
  },
  {
    code: 'super-lucky-caramelo',
    name: 'Super Lucky Caramelo',
    type: 'SLOT',
    rtp: 97,
    maxWin: 50000,
    volatility: 'high',
    status: 'ACTIVE',
    isNew: true,
    created: new Date('2026-05-09'),
    popularIndex: 0,
    isPopular: false,
    preview: 'https://images.rg-aslgna.com/background/Super-Lucky-Caramelo_icon_en%20(1).png',
    provider: { id: 'rc', code: 'rc', name: 'Rectangle Games' },
    providerId: 'rc',
    family: 'caramelo',
  },
  {
    code: 'firecrackers-fortune-2',
    name: 'Firecrackers Fortune 2',
    type: 'SLOT',
    rtp: 97,
    maxWin: 50000,
    volatility: 'high',
    status: 'ACTIVE',
    isNew: true,
    created: new Date('2026-05-09'),
    popularIndex: 0,
    isPopular: false,
    preview: 'https://images.rg-aslgna.com/background/firecrackers-fortune2_icon_en.png',
    provider: { id: 'rc', code: 'rc', name: 'Rectangle Games' },
    providerId: 'rc',
    family: 'firecrackers fortune',
  },
  {
    code: 'treasures-of-hades-2',
    name: 'Treasures of Hades 2',
    type: 'SLOT',
    rtp: 97,
    maxWin: 50000,
    volatility: 'high',
    status: 'ACTIVE',
    isNew: true,
    created: new Date('2026-05-09'),
    popularIndex: 0,
    isPopular: false,
    preview: 'https://cdn.rg-lgna.com/cdn-cgi/image/height=1024,fit=scale-down,format=auto/games/1775817913301-8ZlTsRB4tx.png',
    provider: { id: 'rc', code: 'rc', name: 'Rectangle Games' },
    providerId: 'rc',
    family: 'hades',
  },
];

export const ZH_TW_ONLY_CODES = new Set(ZH_TW_ONLY_GAMES.map((g) => g.code));

export default ZH_TW_ONLY_GAMES;
